import { createFileRoute } from '@tanstack/react-router'
import VerifyEmailConfirmPage from '@/views/verify-email-confirm'

export const Route = createFileRoute('/auth/verify-email-confirm/$uidb64/$token')({
  component: VerifyEmailConfirmPage,
})